import { render, staticRenderFns } from "./QuizThumbnail.vue?vue&type=template&id=f2a3c7a2&scoped=true&"
import script from "./QuizThumbnail.vue?vue&type=script&lang=js&"
export * from "./QuizThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./QuizThumbnail.vue?vue&type=style&index=0&id=f2a3c7a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a3c7a2",
  null
  
)

export default component.exports